var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 689.9 563.3",
    style: {
      enableBackground: "new 0 0 689.9 563.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A3DDB5;}\r\n\t.st1{fill:#36504B;}\r\n\t.st2{fill:#B0F7D5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.4,
    cy: 68.1,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.8,
    cy: 20.3,
    r: 20.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72.8,
    cy: 174.5,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 565,
    cy: 450.3,
    r: 23.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 660.9,
    cy: 410.4,
    r: 28.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 616.6,
    cy: 534.3,
    r: 28.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M585.9,295.1h-66v-38h45c8.3,0,15-6.7,15-15v-134c0-8.3-6.7-15-15-15h-180c-8.3,0-15,6.7-15,15v134 c0,8.3,6.7,15,15,15h45v38h-93.6v-56.8c0-16.2-9.5-31.1-24.2-37.9l-24.1-11.4c9.7-13.2,15.5-29.5,15.5-47.2V115 c0-44-35.8-79.9-79.9-79.9c-11.6,0-22.7,2.5-32.6,7c-9.6-10.6-23.5-17-38.2-17c-28.4,0-51.5,23.1-51.5,51.5 c0,25.3,18.3,46.4,42.4,50.7v14.6c0,17.6,5.7,33.8,15.3,47l-24,11.6c-14.7,6.8-24.1,21.7-24.1,37.9v56.8h-7.1c-8.3,0-15,6.7-15,15 v60c0,8.3,6.7,15,15,15h6v137c0,8.3,6.7,15,15,15h440c8.3,0,15-6.7,15-15v-137h6c8.3,0,15-6.7,15-15v-60 C600.9,301.8,594.2,295.1,585.9,295.1L585.9,295.1z M570.9,355.1h-452v-30h452V355.1z M399.9,123.1h150v104h-31.4 c-4.9-19.5-22.6-34-43.6-34s-38.7,14.5-43.6,34h-31.4V123.1z M459.9,238.1c0-8.3,6.7-15,15-15s15,6.7,15,15v57h-30V238.1z  M173.8,136.6c3.5,0.3,7,0.5,10.5,0.5c32.6,0,63.1-14,86.3-39c1.9,5.3,2.9,10.9,2.9,16.9v26.9c0,27.5-22.4,49.9-49.9,49.9 c-27.5,0-49.9-22.4-49.9-49.9V136.6z M178.7,212.7l4.4-2.1c7.8,4.6,16.4,7.9,25.6,9.7c-0.6,7.8-7,13.9-14.9,13.9 c-8.3,0-15-6.7-15-15L178.7,212.7L178.7,212.7z M264.2,210.7c0.6,0.4,4.5,2.4,4.5,2.4v6.2c0,8.3-6.7,15-15,15 c-7.9,0-14.4-6.1-14.9-13.9C247.9,218.6,256.4,215.3,264.2,210.7L264.2,210.7z M252,74c-18,21.2-42.1,33.2-67.7,33.2 c-3.2,0-6.5-0.2-9.7-0.6c4-23.5,24.5-41.4,49.1-41.4C234.2,65.1,244,68.4,252,74z M131.4,76.6c0-11.9,9.6-21.5,21.5-21.5 c4.9,0,9.5,1.7,13.2,4.6c-9.8,10.2-16.9,23-20.2,37.2C137.5,94,131.4,86,131.4,76.6z M141,238.4c0-4.6,2.7-8.8,6.8-10.7 c0.1,0,1.5-0.7,1.5-0.7c3.7,21.1,22.1,37.3,44.3,37.3c11.5,0,22-4.4,30-11.5c8,7.1,18.5,11.5,30,11.5c22.2,0,40.6-16.1,44.3-37.2 c0,0,1.5,0.7,1.5,0.7c4.2,1.9,6.8,6.1,6.8,10.7v56.8H141L141,238.4z M549.9,507.1h-410v-122h410V507.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.9,511.1v-126h410c-61.6,4.1-142.5,15.6-232.8,45.6C244.9,454.7,185.6,484.2,139.9,511.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono3);
export default __webpack_public_path__ + "static/media/icono3.1f28ab60d77b33dceb20e9f5c4930e99.svg";
export { ForwardRef as ReactComponent };